import moment from 'moment';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { icons } from '~/assets';
import Button from '~/components/button';
import Checkbox from '~/components/checkbox';
import ContainerFlex from '~/components/containerFlex';
import Dialog from '~/components/dialog';
import Input, { MaskTypes } from '~/components/input';
import PasswordModal from '~/components/passwordModal';
import useApi, { ApiMethod } from '~/hooks/useApi';
import { useModal } from '~/hooks/useModal';
import Endpoints from '~/services/endpoints';
import Constants from '~/utils/constants';
import { useInvoiceReprocess } from '../../context';
import { ConfirmSolicitationDialogContent } from '../confirm-solicitation-dialog';

export const SolicitationDecisionActions = ({
  invoiceId,
}: {
  invoiceId: string;
}) => {
  const {
    solicitationData,
    clientData,
    invoiceData,
    selectedItems,
    clearData,
    setNewDate,
    changeDate,
    newDate,
    setTicketNumber,
    ticketNumber,
    setChangeDate,
  } = useInvoiceReprocess();
  const [pwModal, setPwModal] = useState(false);
  const [denyModal, setDenyModal] = useState(false);

  const [denyModalInput, setDenyModalInput] = useState('');

  const PutSolicitationDecision = useApi({
    url: Endpoints.reprocess.putSolicitationDecision.replace(
      'PARAM_ID',
      solicitationData?.id,
    ),
    method: ApiMethod.PUT,
    fetchOnMount: false,
  });
  const PostNewSolicitation = useApi({
    url: Endpoints.reprocess.postNewSolicitation,
    method: ApiMethod.POST,
    fetchOnMount: false,
  });
  const { openModal, closeModal } = useModal();
  const history = useHistory();
  const onSolicitationDecision = async (approve: boolean) => {
    const user = JSON.parse(localStorage.getItem(Constants.USER));

    const response = await PutSolicitationDecision.callApi({
      decisao: approve ? 'APROVAR' : 'NEGAR',
      idOperador: user?.id,
      nomeOperador: user?.nomeTitular,
    });
    if (response.status >= 200 && response.status <= 300) {
      openModal({
        title: approve
          ? 'Reprocessamento aprovado!'
          : 'Reprocessamento reprovado!',
        message: approve
          ? 'As informações estarão disponíveis em breve para o cliente.'
          : 'Esta solicitação foi finalizada',
        positiveLabel: 'Fechar',
        icon: approve ? icons.checkGreen : icons.cancel,
        positiveAction: () => {
          clearData();
          closeModal();
          history.push('/invoice/reprocess/pending');
        },
      });
    } else {
      openModal({
        title: 'Houve um erro',
        message: response?.mensagem || 'Erro não encontrado',
        positiveLabel: 'Fechar',
        icon: icons.exclamation,
      });
    }
  };

  const wrongDateError = () => {
    if (newDate?.length < 10) return true;
    if (!moment(newDate, 'DD/MM/YYYY').isValid()) return true;
    return false;
  };

  if (solicitationData?.id) {
    return (
      <>
        <PasswordModal
          onClose={() => {
            setPwModal(false);
          }}
          buttonDisabledPositive={PutSolicitationDecision.loading}
          onSuccessValidation={() => {
            setPwModal(false);
            onSolicitationDecision(true);
          }}
          open={pwModal}
          title="Aprovar reprocessamento"
          message="Certifique-se de ter validado os dados e digite tua senha para continuar:"
        />
        <Dialog
          icon={icons.exclamation}
          title="Negar reprocessamento"
          message="Para negar este reprocessamento, digite 'negar' na caixa abaixo:"
          positiveLabel="Negar reprocessamento"
          positiveAction={() => {
            setDenyModal(false);
            onSolicitationDecision(false);
          }}
          negativeAction={() => {
            setDenyModalInput('');
            setDenyModal(false);
          }}
          negativeLabel="Voltar"
          buttonDisabledPositive={
            denyModalInput !== 'negar' || PutSolicitationDecision.loading
          }
          widthInPercent={40}
          open={denyModal}
        >
          <ContainerFlex row center horizontal justifyContent="center">
            <ContainerFlex
              marginTop={8}
              maxWidth={50}
              width={50}
              marginBottom={8}
            >
              <Input
                value={denyModalInput}
                onChange={(v) => setDenyModalInput(v.target.value)}
              />
            </ContainerFlex>
          </ContainerFlex>
        </Dialog>
        {solicitationData?.dataNovoVencimento ? (
          <ContainerFlex flex={0} gap="4" marginLeft={28}>
            <ContainerFlex>
              <Input
                label="Solicitante alterou o vencimento para:"
                placeholder="DD/MM/YYYY"
                maxLength={10}
                value={moment(
                  solicitationData.dataNovoVencimento,
                  'YYYY-MM-DD',
                ).format('DD/MM/YYYY')}
                disabled
                mask={MaskTypes.DATE}
              />
            </ContainerFlex>
          </ContainerFlex>
        ) : null}

        <ContainerFlex
          row
          marginTop={16}
          end
          justifyContent="flex-end"
          gap="16"
          flex={0}
        >
          <Button outlined>Voltar</Button>
          <Button onClick={() => setPwModal(true)}>
            Aprovar reprocessamento
          </Button>
          <Button onClick={() => setDenyModal(true)}>
            Negar reprocessamento
          </Button>
        </ContainerFlex>
      </>
    );
  }
  console.log('SELECTED ITEMS', selectedItems);
  console.log('invoiceData invoiceData', invoiceData);
  return (
    <>
      <ContainerFlex flex={0} gap="4" marginLeft={28}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: 4,
            alignItems: 'center',
          }}
          center
          gap="4"
        >
          <Checkbox
            containerProps={{ style: { marginTop: 0 } }}
            value={changeDate}
            onChangeStatus={(v) => {
              setChangeDate(v);
              if (!v) {
                setNewDate('');
              }
            }}
          />
          <span>Desejo alterar a data de vencimento</span>
        </div>
        <ContainerFlex maxWidth={30}>
          <Input
            label="Vencimento"
            disabled={!changeDate}
            placeholder="DD/MM/YYYY"
            maxLength={10}
            value={newDate}
            errorMessage={
              changeDate
                ? wrongDateError()
                  ? 'Insira uma data válida'
                  : null
                : null
            }
            onChange={(e) => {
              return setNewDate(e.target.value.masked);
            }}
            mask={MaskTypes.DATE}
          />
        </ContainerFlex>
      </ContainerFlex>

      <ContainerFlex row end justifyContent="flex-end" gap="16" flex={0}>
        <Button size="small" outlined>
          Voltar
        </Button>
        <Button
          disabled={changeDate ? !!wrongDateError() : false}
          onClick={() => {
            openModal({
              widthInPercent: 80,
              title: 'Confirme todos os dados antes de enviar para aprovação!',
              icon: icons.exclamation,

              positiveAction: undefined,
              negativeLabel: undefined,

              children: (
                <ConfirmSolicitationDialogContent
                  data={invoiceData?.find((f) => f.idFatura === invoiceId)}
                />
              ),
            });
          }}
          size="small"
        >
          Solicitar reprocessamento
        </Button>
      </ContainerFlex>
    </>
  );
};
